<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie/">Техническое освидетельствование опасных производственных объектов: технических устройств, зданий и сооружений
    </div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-zis/">Техническое обследование зданий и сооружений

    </div>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Техническое обследование зданий и сооружений

    </h1>
    <ul class="link-arrow">
      <li>- В Москве и регионах;</li>
      <li>- Опытные специалисты;</li>
      <li>- Собственная лаборатория методов неразрушающего контроля;</li>
    </ul>

    <p>Межгосударственный стандарт, включающий Правила обследования и мониторинга технического состояния зданий и сооружений (ГОСТ 31937-2011), применяется при комплексном обследовании их технического состояния (включая обследование конструкций здания), а также для мониторинга их текущего состояния в целях их дальнейшей и безопасной эксплуатации.</p>

    <h2>Когда нужно проводить техническое обследование зданий и сооружений?</h2>

    <p>Обследование технического состояния здания проводят в соответствии с разработанными программами, но не позднее чем через два года после ввода зданий и сооружений в эксплуатацию. В дальнейшем мониторинг и техническое обследование строительных конструкций, зданий и сооружений при нормальных условиях эксплуатации проводят не менее 1 раза в 10 лет, а при неблагоприятных и тяжелых условиях эксплуатации периодичность обследования - 1 раз в 5 лет.</p>

    <p><strong>Техническое освидетельствование зис и обследование конструкций здания,</strong> включая дымовые трубы, проводится также:</p>

    <ul class="marked ml-50">
      <li>по завершении сроков эксплуатации зданий и сооружений;</li>
      <li>при возникновении повреждений, а также в случае возникновения дефектов и деформаций и т.п.;</li>
      <li>в случае разрушения зданий, сооружений и их конструкций (в т.ч. дымовых труб) в результате стихийных бедствий, аварий и пр.</li>
      <li>при изменении назначения здания или сооружения;</li>
      <li>по инициативе эксплуатирующей организации;</li>
      <li>в случае получения соответствующего предписания от органов, осуществляющих государственный строительный надзор.</li>
    </ul>

    <h2 class="title__red">Наши специалисты проведут:</h2>

    <ul class="marked ml-50">
      <li>Экспертизу промышленной безопасности;</li>
      <li>Техническое диагностирование зданий и сооружений, включая обследование конструкций здания;</li>
      <li>Освидетельствование оборудование и технических устройств;</li>
    </ul>
    <app-recall-form heading="Нет времени изучать детали? Наши специалисты вас проконсультируют"></app-recall-form>
    <h2>Этапы проведения технического обследования ЗиС</h2>

    <p>Техническое обследование зданий и сооружений производится поэтапно:</p>

    <p><strong>1 этап: подготовка к проведению</strong>, включающая получение от заказчика технического задания, поэтажных планов, проектной документации, актов и отчетов предыдущих обследований и пр.,&nbsp;благодаря которым устанавливается информация о здании/сооружении, в т.ч. проектные нагрузки, расчетная схема, характеристики материалов, характер внешних воздействий, износ и т.д. в целях создания программы, содержащей перечень подлежащих обследованию конструкций, элементов, инженерного оборудования и т.д.</p>

    <p><strong>2 этап: визуальный осмотр</strong> (предварительное обследование), позволяющий выявить, установить и оценить дефекты и повреждения по внешним признакам, включающий описание, фотофиксацию и предварительную оценку технического состояния зданий и сооружений.</p>

    <p><strong>3 этап: инструментальное обследование</strong> и диагностирование, включающие определение реальных эксплуатационных нагрузок и воздействий, усилий в несущих конструкциях, фактических характеристик материалов, определение параметров повреждений или дефектов, их анализ и др.</p>

    <h2>Результаты (заключение) проведенного обследования включают в себя:</h2>

    <ul class="marked ml-50">
      <li>категорию технического состояния зданий и сооружений;</li>
      <li>документацию и материалы, служащие обоснованием вышеуказанной категории;</li>
      <li>обоснование причин возникновения повреждений (при их наличии), а также мероприятия, направленные на их устранение, восстановление, усиление конструкции и пр./</li>
    </ul>

    <p><strong>Результаты и заключения оформляются согласно формам Межгосударственного стандарта ГОСТ 31937-2011.</strong></p>
    <div class="blue-block">
        <p>Согласно Федеральному закону от 21.07.1997 № 116-ФЗ &quot;О промышленной безопасности опасных производственных объектов&quot;, организация, эксплуатирующая опасный производственный объект,&nbsp; должна обеспечить своевременное проведение экспертизы промышленной безопасности зданий и сооружений, а также проводить их диагностирование и освидетельствование.</p>
    </div>
    <p><strong>Специалисты ООО &laquo;Протос Экспертиза&raquo; имеют достаточный опыт и квалификацию в области промышленной безопасности, что позволяет нам оказывать широкий спектр услуг, включая технические обследование и освидетельствование, а также экспертизу промышленной безопасности. Полное соблюдение сроков. Собственная ЛНК. Комплексный подход. </strong></p>

    <p><strong>Цена рассчитывается индивидуально.</strong></p>
    <app-atomka-calc heading="Получить консультацию эксперта и последующий расчет стоимости технического освидетельствования"></app-atomka-calc>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
